import { useGroupResponsibleStore } from '@/scopes/account/group-responsible/infrastructure/useGroupResponsibleStore';
import {
  SheetPortal,
  SheetOverlay,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetContentWrapper,
  SheetClose,
  Typography,
} from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { getParticipantExtraInfo } from '../selectors';
import { SheetContentTitle, FieldSection, FieldSectionTitle } from './SheetPortal';

export function ParticipantExtraInfoSheetPortal() {
  const participantExtraInfo = useGroupResponsibleStore(getParticipantExtraInfo);

  const intl = useIntl();

  return (
    <SheetPortal>
      <SheetOverlay />
      <SheetContent $side="right">
        <SheetHeader>
          <SheetTitle>{intl.formatMessage({ id: 'groups_responsible_table_participant' })}</SheetTitle>
          <SheetClose>{intl.formatMessage({ id: 'close' })}</SheetClose>
        </SheetHeader>
        <SheetContentWrapper>
          <SheetContentTitle as="div" $variant="heading-lg">
            {participantExtraInfo.name}
          </SheetContentTitle>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'email_address' })}
            </FieldSectionTitle>
            <Typography>{participantExtraInfo.email}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_booking_number' })}
            </FieldSectionTitle>
            <Typography>{participantExtraInfo.bookingNumber}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_phone' })}
            </FieldSectionTitle>
            {participantExtraInfo.mobileNumber || participantExtraInfo.telephoneNumber ? (
              <>
                <Typography as="div">{participantExtraInfo.mobileNumber}</Typography>
                <Typography as="div">{participantExtraInfo.telephoneNumber}</Typography>
              </>
            ) : (
              <Typography>-</Typography>
            )}
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_accommodation' })}
            </FieldSectionTitle>
            <Typography>{participantExtraInfo.accommodationName}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_room_type' })}
            </FieldSectionTitle>
            <Typography>{participantExtraInfo.roomType}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_ski_pass' })}
            </FieldSectionTitle>
            <Typography>{participantExtraInfo.skiPass}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_ski_material' })}
            </FieldSectionTitle>
            <Typography>{intl.formatMessage({ id: participantExtraInfo.hasSkiMaterial })}</Typography>
          </FieldSection>
          <FieldSection>
            <FieldSectionTitle $variant="body-sm" as="div">
              {intl.formatMessage({ id: 'groups_responsible_totally_sweater' })}
            </FieldSectionTitle>
            <Typography>{intl.formatMessage({ id: participantExtraInfo.hasTotallySweater })}</Typography>
          </FieldSection>
        </SheetContentWrapper>
      </SheetContent>
    </SheetPortal>
  );
}
